var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vue-content-loading",
    {
      attrs: {
        height: 200,
        width: 800,
        speed: 2,
        "primary-color": "#f3f3f3",
        "secondary-color": "#ecebeb",
      },
    },
    [
      _c("rect", {
        attrs: { x: "10", y: "10", rx: "3", ry: "3", width: "60", height: "6" },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "10",
          y: "20",
          rx: "3",
          ry: "3",
          width: "380",
          height: "6",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "410",
          y: "20",
          rx: "3",
          ry: "3",
          width: "380",
          height: "6",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "410",
          y: "10",
          rx: "3",
          ry: "3",
          width: "60",
          height: "6",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: { x: "10", y: "40", rx: "3", ry: "3", width: "60", height: "6" },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "10",
          y: "50",
          rx: "3",
          ry: "3",
          width: "380",
          height: "6",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "410",
          y: "50",
          rx: "3",
          ry: "3",
          width: "380",
          height: "6",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "410",
          y: "40",
          rx: "3",
          ry: "3",
          width: "60",
          height: "6",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: { x: "10", y: "70", rx: "3", ry: "3", width: "60", height: "6" },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "10",
          y: "80",
          rx: "3",
          ry: "3",
          width: "380",
          height: "6",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "410",
          y: "80",
          rx: "3",
          ry: "3",
          width: "380",
          height: "6",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "410",
          y: "70",
          rx: "3",
          ry: "3",
          width: "60",
          height: "6",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "10",
          y: "100",
          rx: "3",
          ry: "3",
          width: "60",
          height: "6",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "10",
          y: "110",
          rx: "3",
          ry: "3",
          width: "380",
          height: "6",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "410",
          y: "110",
          rx: "3",
          ry: "3",
          width: "380",
          height: "6",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "410",
          y: "100",
          rx: "3",
          ry: "3",
          width: "60",
          height: "6",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "10",
          y: "130",
          rx: "3",
          ry: "3",
          width: "60",
          height: "6",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "10",
          y: "140",
          rx: "3",
          ry: "3",
          width: "380",
          height: "6",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "410",
          y: "140",
          rx: "3",
          ry: "3",
          width: "380",
          height: "6",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "410",
          y: "130",
          rx: "3",
          ry: "3",
          width: "60",
          height: "6",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "10",
          y: "160",
          rx: "3",
          ry: "3",
          width: "60",
          height: "6",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "10",
          y: "170",
          rx: "3",
          ry: "3",
          width: "380",
          height: "6",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "410",
          y: "170",
          rx: "3",
          ry: "3",
          width: "380",
          height: "6",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "410",
          y: "160",
          rx: "3",
          ry: "3",
          width: "60",
          height: "6",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }